export const ERROR_REQUIRED = 'is required.';
export const ERROR_EMAIL = 'That doesn’t look like a valid email';
export const ERROR_NUMBER = 'That doesn’t look like a number';
export const ERROR_PASSWORD =
  'Your password can contain the following: a number, a symbol, a capital letter, a lower case letter. It must also be at least 6 characters, with no spaces.';
export const ERROR_PASSWORD_CONFIRM = 'Your passwords don’t match. Double-check and try again.';
export const ERROR_FILE = 'Please select a file';
export const ERROR_GST_NUMBER = 'A valid GST number should contain up to 9 digits, without spaces, hyphens or other characters';
export const TUITION_FEE = 'A line item name "Tutition" is required';
